import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Button, Tips } from 'components'
import { WhiteSpace, WingBlank } from 'antd-mobile'

export default class CampaignRules extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false
    }
  }

  showRuleTips = () => {
    const { handleClick } = this.props // 埋点
    typeof handleClick === 'function' && handleClick()
    this.setState({
      visible: true
    })
  }

  render() {
    const { title = 'Campaign Rules' } = this.props
    return (
      <div className={classes.componentsCampaignRules}>
        <Button
          name='custom'
          inline
          size='small'
          className='pull-right'
          onClick={this.showRuleTips}
        >
          <b>{title}</b>
          <i className='iconfont iconarrow-drow-fill' />
        </Button>
        {this.state.visible && (
          <Tips
            onClose={() => this.setState({ visible: false })}
            showCloseBtn
            wrapClassName={classes.componentsCampaignRulesModal}
          >
            <div className={`text-center ${classes.rules}`}>
              <div className={classes.title}>
                <WhiteSpace size='lg' />
                <p>
                  <b>{title}</b>
                </p>
                <WhiteSpace size='lg' />
              </div>
              <WingBlank className={`font-xs no-scroll-bar ${classes.text}`}>
                {this.props.children}
              </WingBlank>
            </div>
          </Tips>
        )}
      </div>
    )
  }
}
